import React from 'react'
import {classNames} from "../../../../util/util-helpers";

export default function CellButton({onClick, appearance, className, addClass, disabled, children, isTruncated = true}) {
    let buttonClass = getButtonClass(appearance);

    function getButtonClass() {
        let baseClass = "cursor-pointer leading-5 inline-flex py-0.5 -mx-2 px-2 rounded-btn text-left disabled:text-tm-gray-700 disabled:hover:text-tm-gray-700 disabled:hover:bg-transparent  font-btn font-mediu focus:outline-hidden focus:ring-0"
        switch (appearance) {
            case 'warning':
                return classNames(baseClass, "hover:text-yellow-600 text-yellow-600 hover:text-yellow-600 hover:bg-yellow-600/10 focus-visible:bg-red-yellow/10")
            case 'danger':
                return classNames(baseClass, "hover:text-red-600 text-red-600 hover:text-red-600 hover:bg-red-600/10 focus-visible:bg-red-600/10")
            case 'success':
                return classNames(baseClass, "hover:text-green-600 text-green-600 hover:text-green-600 hover:bg-green-600/10 focus-visible:bg-green-600/10")
            default:
                return  classNames(baseClass, "hover:text-primary text-primary-shade hover:text-tm-gray-900 hover:bg-primary-transparent focus-visible:bg-primary-transparent")
        }
    }

    return <button
        className={classNames(
            className ?? buttonClass,
            addClass,
            isTruncated ? "truncate" : undefined
        )}
        disabled={disabled}
        onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onClick();
        }}>

        {children}

    </button>
}
